
import { Options, mixins } from "vue-class-component";
import { RoutingUtilityMixin, AlbumAndAssetManagementMixin } from "@/mixins";
import { AssetsInterface, FoldersWithAssetsInterface } from "@/types";
import SvgIcon from "@/components/ui/BaseIcons/SvgIcon.vue";
import { assetsModule } from "@/store";
import { useMq } from "vue3-mq";

const ASSETS_ROUTE = "3d-viewer/albums/asset";
const ALBUMS_ROUTE = "3d-viewer/albums";

@Options({
  name: "Breadcrumbs",
  components: { SvgIcon },
})
export default class Breadcrumbs extends mixins(
  RoutingUtilityMixin,
  AlbumAndAssetManagementMixin
) {
  private mq = useMq();

  protected get getAssetData(): AssetsInterface | undefined {
    return assetsModule.getAssetsData.find(
      (a) => a.slug === this.$route.params.assetSlug
    );
  }

  protected get breadcrumbsPath(): Array<{ [key: string]: string }> | [] {
    if (this.isAssetsRoute) {
      return this.isRouteValid
        ? this.getFullAssetRoute(this.getAssetData, ["name", "slug"])
        : [];
    }

    const slugs = this.getAlbumPathArray;
    const slug = slugs[slugs.length - 1];

    if (slug === "newest") {
      return [{name: "Newest", slug: "newest"}]
    }

    return this.getAlbumPathBySlugs(slug, ["name", "slug"]) || [];
  }

  protected get getDefaultAlbums(): FoldersWithAssetsInterface[] {
    const isDesktop = ["lg", "xl", "xxl"].includes(this.mq.current);

    if (isDesktop) {
      return assetsModule.getFilteredAlbums;
    }

    return assetsModule.getFoldersWithAssets;
  }

  protected get isRouteValid(): boolean {
    const { assetSlug } = this.$route.params;
    const asset = this.findAssetBySlug(
      this.getDefaultAlbums,
      assetSlug as string
    );

    return this.isRoutePathValid(this.$route.path, asset);
  }

  protected generatePath(index: number): string {
    const basePath = "/albums";
    const pathSegments = this.breadcrumbsPath
      .slice(0, index + 1)
      .map((item) => item.slug);

    return this.constructLocaleAwarePath(`${basePath}/${pathSegments.join("/")}`);
  }

  protected isNotLastIndex(index: number): boolean {
    return index < this.breadcrumbsPath.length - 1;
  }

  protected get isAlbumsRoute(): boolean {
    return this.$route.name == ALBUMS_ROUTE;
  }

  protected get isAssetsRoute(): boolean {
    return this.$route.name == ASSETS_ROUTE;
  }
}
